import { useRef } from "react";
import { Link2, Loader2, Send, Store, UserRound } from "lucide-react";
import BotoesMensagem from "./BotoesMensagem";
import { COMANDOS, nomeTecnico } from "./modelos";

const ICONES = { nome: UserRound, empresa: Store, link: Link2 };

/**
 * Mensagem própria da loja: nome do modelo, texto com os comandos prontos
 * (nome do cliente, nome da loja, link rastreável) e os botões. O celular ao
 * lado mostra a prévia enquanto a loja escreve.
 */
// "{nome} ," → "{nome},": o espaço que o botão põe depois do comando some
// quando a loja continua com pontuação.
const colarPontuacao = (t) => t.replace(/(\{(?:nome|empresa|link)\}) ([,.!?;:])/g, "$1$2");

export default function EditorMensagem({ rascunho, setRascunho, onEnviar, enviando, aviso, telefoneLoja, nomePadrao }) {
  const ref = useRef(null);
  const tecnico = nomeTecnico(rascunho.titulo || nomePadrao);

  const inserir = (token) => {
    const el = ref.current;
    const t = rascunho.texto;
    const ini = el ? el.selectionStart : t.length;
    const fim = el ? el.selectionEnd : t.length;
    const antes = t.slice(0, ini), depois = t.slice(fim);
    const pre = antes && !/\s$/.test(antes) ? " " : "";
    const pos = !depois || /^[\p{L}\p{N}]/u.test(depois) ? " " : "";
    const novo = `${antes}${pre}${token}${pos}${depois}`;
    setRascunho({ ...rascunho, texto: novo });
    const cursor = (antes + pre + token + pos).length;
    setTimeout(() => { el?.focus(); el?.setSelectionRange(cursor, cursor); }, 0);
  };

  return (
    <div className="space-y-4">
      <div>
        <label className="text-sm font-semibold">Nome do modelo</label>
        <input value={rascunho.titulo} onChange={(e) => setRascunho({ ...rascunho, titulo: e.target.value })}
          placeholder={nomePadrao || "Ex.: Oferta da semana"} maxLength={60}
          className="mt-1.5 w-full rounded-lg border bg-background px-3 py-2 text-sm" />
        <p className="mt-1 text-[11px] text-muted-foreground">
          {!rascunho.titulo && nomePadrao ? "Em branco, usa o nome da campanha. " : ""}
          {tecnico && <>Na Meta ele aparece como <code>{tecnico}</code></>}
        </p>
      </div>

      <div>
        <div className="flex items-end justify-between gap-2">
          <label className="text-sm font-semibold">Mensagem</label>
          <span className="text-[11px] text-muted-foreground tabular-nums">{rascunho.texto.length}/1000</span>
        </div>
        <div className="mt-1.5 flex flex-wrap gap-2">
          {Object.entries(COMANDOS).map(([tipo, c]) => {
            const Icone = ICONES[tipo];
            return (
              <button key={tipo} type="button" onClick={() => inserir(c.token)} title={c.dica}
                className="inline-flex items-center gap-1.5 rounded-full border border-[#25d366]/60 bg-[#25d366]/10 px-3 py-1 text-xs font-semibold text-[#0a7d5a] dark:text-[#4ade80] hover:bg-[#25d366]/20">
                <Icone className="h-3.5 w-3.5" /> {c.rotulo}
              </button>
            );
          })}
        </div>
        <textarea ref={ref} value={rascunho.texto} onChange={(e) => setRascunho({ ...rascunho, texto: colarPontuacao(e.target.value) })}
          rows={7} maxLength={1000}
          placeholder={"Ex.: Oi {nome}, tudo bem? 😄\nEssa semana o *X-Burger* está com preço especial aqui na {empresa}.\nPeça aqui: {link} Te esperamos!"}
          className="mt-2 w-full rounded-lg border bg-background px-3 py-2 text-sm leading-relaxed" />
        <p className="mt-1 text-[11px] text-muted-foreground">
          Os botões verdes colocam o comando onde está o cursor. *Negrito* e _itálico_ funcionam como no WhatsApp.
        </p>
      </div>

      <BotoesMensagem botoes={rascunho.botoes} setBotoes={(b) => setRascunho({ ...rascunho, botoes: b })}
        telefoneLoja={telefoneLoja} />

      {aviso && <p className={`text-sm ${aviso.tipo === "ok" ? "text-emerald-600" : "text-destructive"}`}>{aviso.txt}</p>}
      <button type="button" onClick={onEnviar} disabled={enviando}
        className="w-full inline-flex items-center justify-center gap-2 rounded-lg bg-[#00a884] px-4 py-2.5 text-sm font-semibold text-white hover:bg-[#008f72] disabled:opacity-60">
        {enviando ? <Loader2 className="h-4 w-4 animate-spin" /> : <Send className="h-4 w-4" />} Enviar para aprovação da Meta
      </button>
      <p className="text-[11px] text-muted-foreground text-center">
        Toda mensagem de marketing no WhatsApp passa pela aprovação da Meta. Costuma sair em minutos (às vezes até 24 h); aprovada, ela aparece em Modelos prontos.
      </p>
    </div>
  );
}
